module.exports = "a{\n\ttext-decoration: none;\n}\n\n.dpp_date{\n\tposition: relative;\n    top: -4px;\n}\n\n.dpp_date_icon{\n\tposition: relative;\n    top: 3px;\n}\n\ndiv.error_warning{\n\ttext-align: center;\n    margin-top: 32px;\n    padding: 10px;\n    color: red;\n    font-weight: bold;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/usage-payments/dpp-usage/dpp-usage.component.css
// module id = ./src/app/payment/usage-payments/dpp-usage/dpp-usage.component.css
// module chunks = main